import { PageSectionPrimary, TextMask } from 'ui/components'

import { useHRRContext } from '../../context'
import {
  DepositsFromSales,
  License,
  OtherBankingActivity,
  SalesReportTable,
  SalesToDepositComparison,
  Warnings
} from './components'

export const BankAccounts = () => {
  const { data } = useHRRContext()
  const { bankAccounts, highRiskReviewId } = data

  return (
    <>
      {bankAccounts.map((acc, i) => {
        const { bankAccountNumber, showWarnings, salesSourceItems } = acc

        return (
          <PageSectionPrimary
            title={
              <div style={{ display: 'flex', gap: '10px' }}>
                <h3>Bank Account #{i + 1}</h3>
                <TextMask text={bankAccountNumber} isBankAccount />
              </div>
            }
            anchor={`bank-account-${i}`}
            face="solid"
            expanded
            foldable
            key={bankAccountNumber}
          >
            {showWarnings?.length > 0 && <Warnings warnings={showWarnings} />}
            <SalesReportTable bankAccount={acc} />
            <div style={{ marginBottom: '20px' }}>
              {salesSourceItems.map((item) => (
                <License salesSourceItem={item} key={item.licenseId} highRiskReviewId={highRiskReviewId} />
              ))}
            </div>
            <DepositsFromSales bankAccount={acc} highRiskReviewId={highRiskReviewId} index={i} />
            <OtherBankingActivity bankAccount={acc} />
            <SalesToDepositComparison bankAccount={acc} />
          </PageSectionPrimary>
        )
      })}
    </>
  )
}
